import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import { ClassificationType } from "../../models/classification-type";
import {Columns} from "../../models/formio/columns";
import {Panel} from "../../models/formio/panel";

@Injectable()
export class FormioControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getFormCatalogs(): Observable<ClassificationType[]> {
    return this.http.get(this.baseUrl + "classifications?ignoreFields=true") as Observable<ClassificationType[]>;
  }

  public getFormCollectionPlaces(serviceId: string): Observable<Columns[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/formio/collectionPlaces") as Observable<Columns[]>;
  }

  public getFormRequirements(serviceId: string): Observable<Columns> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/formio/requirements") as Observable<Columns>;
  }

  public getMyApplicationsComponent(serviceId: string): Observable<Panel> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/formio/my_applications") as Observable<Panel>;
  }

}
